import { render, staticRenderFns } from "./FolderMediaCard.vue?vue&type=template&id=049484e4&scoped=true&"
import script from "./FolderMediaCard.vue?vue&type=script&lang=js&"
export * from "./FolderMediaCard.vue?vue&type=script&lang=js&"
import style0 from "./FolderMediaCard.vue?vue&type=style&index=0&id=049484e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049484e4",
  null
  
)

export default component.exports